import React from "react";
import {
	IconButton,
	Dropdown,
	DropdownMenuButton,
} from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

interface Props {
	row: {
		index: number;
	};
	disabled: boolean;
	setFormAction?: React.Dispatch<
		React.SetStateAction<{
			type: "VIEW" | "EDIT" | "CREATE";
			index: number;
		} | null>
	>;
	showEdit?: boolean;
	showView?: boolean;
}
const ViewDropdown = ({
	row,
	disabled,
	setFormAction,
	showEdit,
	showView,
}: Props) => {
	const { t } = useTranslation();

	return (
		<div className="customView-actions">
			<Dropdown
				id={`view_dropdown__${row.index}`}
				disabled={disabled}
				align="right"
				menuBtn={
					<IconButton
						icon="ellipsis-v"
						label={t("main.labels.menu")}
						className="btn-basic--default btn--round"
					/>
				}>
				{showEdit && (
					<DropdownMenuButton
						label={t("common.labels.edit")}
						onClick={() => {
							if (setFormAction)
								setFormAction({
									type: "EDIT",
									index: row.index,
								});
						}}
					/>
				)}
				{showView && (
					<DropdownMenuButton
						label={t("common.labels.view")}
						onClick={() => {
							if (setFormAction)
								setFormAction({
									type: "VIEW",
									index: row.index,
								});
						}}
					/>
				)}
			</Dropdown>
		</div>
	);
};

export default React.memo(ViewDropdown);
